import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipProgramComponent } from './tip-program.component';
import { AddTipProgramComponent } from './add-tip-program/add-tip-program.component';
import { EditTipProgramComponent } from './edit-tip-program/edit-tip-program.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';


@NgModule({
    declarations: [
        TipProgramComponent,
        AddTipProgramComponent,
        EditTipProgramComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TipProgramComponent]
})
export class TipProgramModule { }
